import { memo } from 'react'

import { Tooltip } from '@mui/material'
import { useSnackbar } from 'notistack'
import CopyToClipboard from 'react-copy-to-clipboard'
import { useTranslation } from 'react-i18next'

import { CodeInline } from '@shared/components/MaterialUIEnhancements/CodeInline'

type CopyIdProps = {
  id: string
}

const CopyIdRaw = ({ id }: CopyIdProps) => {
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()

  return (
    <CopyToClipboard
      text={id}
      onCopy={() => {
        enqueueSnackbar(t('copiedToClipboard'), {
          variant: 'info',
        })
      }}
    >
      <Tooltip title={t('clickToCopy')} placement="top">
        <CodeInline sx={{ cursor: 'copy' }}>{id}</CodeInline>
      </Tooltip>
    </CopyToClipboard>
  )
}

export const CopyId = memo(CopyIdRaw)
